import apiFetch from '@wordpress/api-fetch';
import { BookrWpOptions } from '../models/bookr-wp-options';

export async function getWpBookrSettings(): Promise<BookrWpOptions> {
	const response: any = await apiFetch({
		path: '/wp/v2/settings',
		method: 'GET',
	});

	return response.bookr_settings;
}

export async function saveWpSettings(bookrWpOptions: BookrWpOptions): Promise<any> {
	const response = await apiFetch({
		path: '/wp/v2/settings',
		method: 'POST',
		data: {
			bookr_settings: bookrWpOptions,
		},
	});

	return response;
}
